import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './BlogPage.css';

const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load the posts manifest
    fetch('/blog/posts.json')
      .then(res => res.json())
      .then(data => {
        // Sort by date, newest first
        const sorted = data.posts.sort((a, b) =>
          new Date(b.date) - new Date(a.date)
        );
        setPosts(sorted);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load blog posts:', err);
        setLoading(false);
      });
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="blog-page">
      {/* Background */}
      <div className="blog-bg">
        <div className="bg-gradient" />
        <div className="grid-pattern" />
        <div className="glow-orb orb-1" />
        <div className="glow-orb orb-2" />
      </div>

      {/* Hero */}
      <section className="blog-hero">
        <div className="section-container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="section-label">Insights & Updates</span>
            <h1>Blog</h1>
            <p className="hero-subtitle">
              Thoughts on robotics, AI, and building in the open.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Posts List */}
      <section className="blog-content">
        <div className="section-container">
          {loading ? (
            <div className="blog-loading">Loading posts...</div>
          ) : posts.length === 0 ? (
            <motion.div
              className="blog-empty"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
            >
              <p>No posts yet. Check back soon!</p>
            </motion.div>
          ) : (
            <div className="blog-posts-grid">
              {posts.map((post, index) => (
                <motion.article
                  key={post.slug}
                  className="blog-post-card"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1, duration: 0.5 }}
                >
                  <Link to={`/blog/${post.slug}`} className="post-link">
                    <div className="post-meta">
                      <time dateTime={post.date}>{formatDate(post.date)}</time>
                      {post.tags && post.tags.length > 0 && (
                        <div className="post-tags">
                          {post.tags.slice(0, 3).map(tag => (
                            <span key={tag} className="post-tag">{tag}</span>
                          ))}
                        </div>
                      )}
                    </div>
                    <h2>{post.title}</h2>
                    {post.description && (
                      <p className="post-excerpt">{post.description}</p>
                    )}
                    <span className="read-more">Read more →</span>
                  </Link>
                </motion.article>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Back Link */}
      <div className="section-container">
        <motion.div
          className="back-link"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <Link to="/">← Back to Home</Link>
        </motion.div>
      </div>
    </div>
  );
};

export default BlogPage;
